const WHITE_LIST = ['theme', 'design_code', 'product'];

const setCanonicalUrl = (window, whiteListedFilters = []) => {
  const canonical_variables = url => {
    if(url.indexOf('?') === -1) {
      return url;
    }

    const searchQuery = url
      .substr(1)
      .split(/&/)
      .reduce((output, str) => {
        const whiteListed = WHITE_LIST.concat(whiteListedFilters).some(v => decodeURIComponent(str).includes(`${v}=`));

        if (whiteListed) {
          output.push(str);
        }

        return output;
      }, []);

    return searchQuery.length === 0 ? '' : '?' + searchQuery.join('&');
  };

  const transform_path = pathname => {
    if (pathname == '/order/prints-builder') {
      return '/about/prints';
    }
    return pathname;
  };

  let canonical_link = document.querySelector('link[rel=canonical]');

  const hasTheme = window.location.search.includes("theme");
  const hasDesignCode = window.location.search.includes("design_code");

  const hasThemeAndDesignCode = hasTheme && hasDesignCode;
  const noThemeAndDesignCode = !hasTheme && !hasDesignCode;

  if (!canonical_link) {
    canonical_link = document.createElement('link');
    canonical_link.rel = 'canonical';
    document.head.appendChild(canonical_link);
  }

  if (hasThemeAndDesignCode || noThemeAndDesignCode) {
    return (
      canonical_link.href = '' +
      window.origin +
      transform_path(window.location.pathname) +
      canonical_variables(window.location.search)
    )
  }

  return canonical_link.href;
};

export default setCanonicalUrl;
